module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/new_marker.56f6473f.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/new_marker.png
// module id = 3027
// module chunks = 11